import React from 'react'

type Props = {}

export default function DeleteAccount() {
  return (
    <div>Delete Account – Spray Assure

Spray Assure respects your privacy and gives you control over your personal data.

If you wish to permanently delete your Spray Assure account and associated data, please follow the instructions below.

How to Request Account Deletion

You can request account deletion by:

Sending an email to:
support@bharatrohan.in

Mentioning the following details in your email:

Your registered phone number

Your full name used in the app

What Happens After You Submit a Request

After we receive your request:

Your account will be permanently deleted.

Personal information such as your name, phone number, and location details will be removed from our systems.

Booking history and associated account data will be deleted.

Your data will be permanently removed within 7 working days.

Data Retention

Certain transactional or legal records may be retained if required to comply with applicable laws, regulatory requirements, or for fraud prevention purposes.
This deletion process applies to users of the Spray Assure mobile application.

Contact Us

If you have any questions regarding account deletion or your personal data, please contact:

BharatRohan Airborne Innovations Ltd.
Email: support@bharatrohan.in

Website: https://bharatrohan.in</div>
  )
}